import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'; // 引入 vuex-persistedstate 插件

const store = createStore({
  state: {
    // 初始化用户状态
    user: {
      id: null,
      name: '',
      email: '',
      role: 0
    }
  },
  mutations: {
    // 设置用户信息state 相当于key, userData相当于value
    setUser(state, userData) {
      state.user = userData
    },
    // 清除用户信息
    clearUser(state) {
      state.user = {
        id: null,
        name: '',
        email: '',
        role: 0
      }
    }
  },
  actions: {
    // 异步设置用户信息
    async setUser({ commit }, userData) {
      // 模拟异步操作，比如从API获取数据
      commit('setUser', userData)
    },
    async logout({ commit }) {
      // 模拟注销操作
      commit('clearUser')
    },
  },
  getters: {
    // 获取用户信息
    getUser(state) {
      return state.user
    },
    // 检查用户是否登录
    isUserLoggedIn(state) {
      return state.user.id !== null
    }
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage, // 你可以选择使用 localStorage 或 sessionStorage
    })
  ]
})

export default store